module.exports = __webpack_public_path__ + "static/media/networkingP.35dec599.jpg";